
import { useAxios } from '../../../../../../../hooks/useAxios';
import { useAxiosFake } from '../../../../../../../hooks/useAxiosFake';
import { AparatosAdapters } from '../adapters/aparatos.adapter';

const AparatosServices = {

    GET: function () {

        return useAxios({ method: 'get', url: `/slam/productos`, type: 'json', adapters: AparatosAdapters.GET })
    },
}

export {
    AparatosServices
}